import {ConditionParameterService} from "../../services/ConditionParameterService";
import {IComponentController} from "angular";
import {CalculatorParameter} from "../../model/CalculatorParameter";

export interface EditParameterComponentScope {
    parameter: CalculatorParameter
}

export abstract class AbstractEditParameterComponent implements IComponentController {

    protected $scope: EditParameterComponentScope;
    protected $mdDialogService: angular.material.IDialogService;
    protected parameterService: ConditionParameterService;
    protected parameter: CalculatorParameter;

    protected static controllerInstance: any[] = ['$scope', '$mdDialog'];
    protected static instance = () => ({
        bindings: {
            parameter: '=',
        }
    });

    constructor(
        $scope: EditParameterComponentScope,
        $mdDialogService: angular.material.IDialogService,
        parameterService: ConditionParameterService
    ) {
        this.$scope = $scope;
        this.$mdDialogService = $mdDialogService;
        this.parameterService = parameterService;
    }

    $onInit(): void {
        // this.originalParameter = Object.assign(this.parameter);
        this.$scope.parameter = this.parameter;
    }

}